/**
 * State used in rendering TagPickerOptionGroup
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
